<template>
  <div id="app-about-support">
    <h1>为所有3D艺术家制作一个公共资产库 <em class="el-icon-money"></em></h1>
    <p>
      在大多数情况下，资产能够给艺术家起到极大的帮助和效率的提升，但对于国内3D艺术家
      来说，找到放心使用的资产库，是十分困难的。因为任何来历不明的资产，就和盗版国内外
      视频或软件一样，一旦发布，在未来任何一天就可能变成原创方的维权证据，所以在这里为
      了改善我们大家的资产生态，决心在这里开始启动定时开源生态计划。
    </p>
    <div id="app-about-support-body">
      <div class="app-about-support-process-body">
        <div class="app-about-support-process-title">开源HDR项目</div>
        <el-progress class="app-about-support-process" :text-inside="true" :stroke-width="24" :percentage="100"
                     status="success"></el-progress>
      </div>
      <div class="app-about-support-process-body">
        <div class="app-about-support-process-title">开源纹理项目</div>
        <el-progress class="app-about-support-process" :text-inside="true" :stroke-width="22" :percentage="80"
                     status="warning"></el-progress>
      </div>
      <div class="app-about-support-process-body">
        <div class="app-about-support-process-title">开源模型项目</div>
        <el-progress class="app-about-support-process" :text-inside="true" :stroke-width="26"
                     :percentage="70"></el-progress>
      </div>
      <div class="app-about-support-process-body">
        <div class="app-about-support-process-title">你说要四个</div>
        <el-progress class="app-about-support-process" :text-inside="true" :stroke-width="20" :percentage="50"
                     status="exception"></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutSupport"
}
</script>

<style scoped>

#app-about-support {
  width: 100%;
  text-align: center;
  padding-top: 25px;
}

#app-about-support h1 {
  margin: auto auto 15px;
}

#app-about-support p {
  width: 800px;
  margin: auto;
  text-align: left;
  line-height: 25px;
  letter-spacing: 1px;
  text-indent: 32px;
}

#app-about-support-body {
  width: 80%;
  text-align: left;
  margin: auto;
}

.app-about-support-process-body {
  margin: 25px;
}

.app-about-support-process {
  margin-top: 25px;
}

</style>